export default __webpack_public_path__ + "static/img5-71edf432fbc52c1d5cd89eab5fa503b6.jpg";